import React, { useEffect, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import useAuth from '@contexts/useAuth';
import { billingConfirm } from '@api/billing';

/**
 * Handles the Stripe Checkout redirect for authenticated (ACTIVE) users.
 * Calls the /confirm endpoint to ensure credits are granted even if
 * the webhook is delayed, then redirects to the settings billing page.
 */
const BillingSuccess: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const confirmedRef = useRef(false);

  useEffect(() => {
    if (confirmedRef.current) return;
    confirmedRef.current = true;

    const sessionId = searchParams.get('session_id');

    const confirm = async () => {
      if (sessionId && user?.token) {
        try {
          await billingConfirm(user.token, sessionId);
        } catch {
          // Best-effort: webhook will handle it if confirm fails
        }
      }
      navigate('/settings/billing', { replace: true });
    };

    confirm();
  }, [user, searchParams, navigate]);

  return null;
};

export default BillingSuccess;
